import { render } from "./mapArea.vue?vue&type=template&id=b2585122"
import script from "./mapArea.vue?vue&type=script&lang=js"
export * from "./mapArea.vue?vue&type=script&lang=js"

import exportComponent from "/home/gitlab-runner/builds/c7p4yP7J/0/platform/zhenwu/iot-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/divform/mapArea.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b2585122"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b2585122', __exports__)) {
    console.log('reload')
    api.reload('b2585122', __exports__)
  }
  
  module.hot.accept("./mapArea.vue?vue&type=template&id=b2585122", () => {
    console.log('re-render')
    api.rerender('b2585122', render)
  })

}


export default __exports__